export default __webpack_public_path__ + "static/media/IMG_5567.0aae3f37.jpg";